export default {
  delete: 'Delete',
  edit: 'Edit',
  cancel: 'Cancel',
  clear: 'Clear',
  new: 'New',
  update: 'Update',
  undo: 'Undo',
  option: 'Option',
  details: 'Details',
  deleting: 'Deleting',
  createdAt: 'Created At',
  firstSeen: 'First Seen',
  lastActive: 'Last Active',
  'idle.title': 'Your session is about to expire',
  'idle.content': 'Resume the session now or logout',
  resume: 'Resume',
  name: 'Name',
  'success.reloading': 'Successful, reloading page',
  'fail.retry': 'Failed, please try again',
  tags: 'Tags',
  after: 'After',
  flow: 'Flow',
  text: 'Text',
  image: 'Image',
  video: 'Video',
  file: 'File',
  custom: 'Custom',
  input: 'Input',
  quickReplies: 'Quick Replies',
  ctaUrl: 'CTA Url',
  button: 'Button',
  question: 'Question',
  fieldRequired: 'This field is required',
  entity: 'Entity',
  active: 'Active',
  inactive: 'Inactive',
  deleted: 'Deleted',
  next: 'Next',
  category: 'Category',
  portalUser: 'Portal User',
  role: 'Role',
  admin: 'Admin',
  user: 'User',
  username: 'Username',
  email: 'Email',
  firstName: 'First Name',
  lastName: 'Last Name',
  fullName: 'Full Name',
  resetPassword: 'Reset Password',
  'resetPassword.emailSent': 'Password reset email has been sent to the user',
  'resetPassword.confirm.title': 'Reset password for this user?',
  'resetPassword.confirm.content': 'A password reset email will be sent to {username} ({email})',
  'resetPassword.emailFailed': 'Failed to send reset email, please try again',
  'resetPassword.tokenExpired': 'Reset Password Token expired',
  oldPassword: 'Current Password',
  newPassword: 'New Password',
  'password.characterNotMet':
    'Password must contain at least one letter, one number, and one special character',
  confirmPassword: 'Confirm Password',
  'confirmPassword.mismatch': 'The two passwords that you entered do not match!',
  unlock: 'Unlock',
  'portalUser.unlock.title': 'Unlock the user',
  'portalUser.unlock.content':
    '{username} ({email}) - A password reset email will be sent to the user',
  logout: 'Log Out',
  dormant: 'Dormant',
  'portalUser.dormant.title': 'Are you sure to dormant this user?',
  'portalUser.dormant.content':
    '{username} ({email}) - Please note that after dormancy, this user cannot access this portal any more',
  reactivate: 'Reactivate',
  'portalUser.reactivate.title': 'Are you sure to reactivate this user?',
  'portalUser.reactivate.content':
    '{username} ({email}) - Please note that after reactivating, this user will gain access this portal immediately',
  'portalUser.delete.title': 'Are you sure to delete this user?',
  'portalUser.delete.content':
    '{username} ({email}) - Please note that after deletion, this user cannot access this portal any more. Personal data will be erased, alternatively, you may dormant the user.',
  'portalUser.delete.undo': '{username} ({email}) deleted',
  'portalUser.emailChange.title': 'Change user email?',
  'portalUser.emailChange.content':
    'The email will be updated to {newEmail} and a password reset email will be sent to that address. The user will be logged out and must set a new password to log in again.',
  'portalUser.emailChange.noEmail.content':
    'The email will be updated to {newEmail}. Email service is not configured for this organisation, so a new password will be generated and shown to you to share with the user.',
  platform: 'Platform',
  notes: 'Notes',
  'pages.login.rememberMe': 'Remember me',
  'pages.login.forgotPassword': 'Forgot Password ?',
  'pages.welcome.alertMessage': 'Faster and stronger heavy-duty components have been released.',
  'pages.admin.subPage.title': 'This page can only be viewed by Admin',
  'portalUser.userPasswordModal.title': 'หน้าต่างรหัสผ่านผู้ใช้',
  'pages.review.title': 'ตรวจสอบ',
  'pages.review.description':
    'สร้างการตรวจสอบเชิงโครงสร้างของเอกสารหนึ่งฉบับหรือมากกว่า โดยอิงตามรายการคำถามของคุณ',
  'pages.file.placeholder.type': 'ประเภท',
  'pages.file.placeholder.people': 'ผู้สร้าง',
  'pages.file.placeholder.search': 'ค้นหาไฟล์หรือโฟลเดอร์',
  'pages.file.placeholder.editfile': 'แก้ไขชื่อไฟล์',
  'pages.file.pdf': 'PDF',
  'pages.file.document': 'เอกสาร',
  'pages.file.msg': 'MSG',
  'pages.file.eml': 'EML',
  'pages.file.txt': 'ข้อความ',
  'pages.file.md': 'Markdown',
  'pages.file.excel': 'Excel',
  'pages.file.powerpoint': 'PowerPoint',
  'pages.file.uploading': 'กำลังอัปโหลด',
  'pages.file.clickDragFile': 'คลิกหรือลากไฟล์มาที่นี่เพื่ออัปโหลด',
  'pages.file.createfolder': 'สร้างโฟลเดอร์',
  'pages.file.uploadFiles': 'อัปโหลดไฟล์',
  'pages.file.upload.time': 'เวลาอัปโหลด:',
  'pages.file.created.time': 'เวลาที่สร้าง:',
  'pages.file.favorites': 'รายการโปรดของฉัน',
  'pages.file.history': 'ประวัติการแก้ไข',
  'pages.file.success': 'สร้างสำเร็จ',
  'pages.file.filePreview': 'ตัวอย่างไฟล์',
  'pages.file.prompt.uploadFiled': 'อัปโหลดล้มเหลว',
  'pages.file.prompt.network': 'เกิดข้อผิดพลาดของเครือข่าย',
  'pages.file.prompt.fetchFiles': 'ไม่สามารถดึงข้อมูลรายการไฟล์ได้',
  'pages.file.prompt.createGroup': 'สร้างกลุ่มไม่สำเร็จ',
  'pages.file.prompt.createFolderSucc': 'สร้างโฟลเดอร์สำเร็จ',
  'pages.file.prompt.createFolderFail': 'สร้างโฟลเดอร์ไม่สำเร็จ',
  'pages.file.prompt.updateSucc': 'อัปเดตสำเร็จ',
  'pages.file.prompt.updateFail': 'อัปเดตไม่สำเร็จ',
  'pages.file.prompt.addFavoriteFail': 'เพิ่มไม่สำเร็จ',
  'pages.file.prompt.noPermission': 'คุณไม่มีสิทธิ์แก้ไขเซสชันนี้',
  'pages.file.prompt.duplicateName': 'ชื่อเซสชันซ้ำ',
  'pages.file.prompt.notFound': 'ไม่พบเซสชัน',
  'pages.file.prompt.deleteGroupSuc': 'ลบสำเร็จ',
  'pages.file.prompt.uploadFiles': 'ไฟล์พร้อมที่จะอัปโหลด',
  'pages.file.prompt.downloadSucc': 'ดาวน์โหลดสำเร็จ',
  'pages.file.prompt.downloadFail': 'ดาวน์โหลดไม่สำเร็จ',
  'pages.file.prompt.authFail': 'ไม่มีโทเค็นการอนุญาต',
  'pages.file.prompt.moveSucc': 'ย้ายไฟล์สำเร็จ',
  'pages.chat.newWithUploadedDocument': 'แชทใหม่พร้อมเอกสาร',
  'pages.chat.editSessionName': 'แก้ไขชื่อเซสชัน',
  'pages.chat.placeholder.inputSessionName': 'ป้อนชื่อเซสชันใหม่',
  'pages.chat.placeholder': 'เขียนสิ่งที่คุณต้องการถาม...',
  'pages.chat.word': '/10000 ตัวอักษร',
  'pages.chat.rateMessage.successfulLike': 'กดถูกใจข้อความสำเร็จ',
  'pages.chat.rateMessage.successfulDislike': 'กดไม่ถูกใจข้อความสำเร็จ',
  'pages.chat.actions.like': 'การตอบกลับที่ดี',
  'pages.chat.actions.dislike': 'การตอบกลับที่ไม่ดี',
  'pages.chat.rateMessage.error': 'ให้คะแนนข้อความไม่สำเร็จ',
  'pages.chat.selectContext.setFilePriority.success': 'อัปเดตลำดับความสำคัญของไฟล์สำเร็จ',
  'pages.chat.selectContext.setFilePriority.error':
    'เกิดข้อผิดพลาดในการอัปเดตลำดับความสำคัญของไฟล์',
  'pages.chat.selectContext.toolTipDefault':
    'โดยค่าเริ่มต้น บอทจะสามารถเข้าถึงไฟล์ทั้งหมดที่คุณมีสิทธิ์เข้าถึง',
  'pages.chat.rerank':
    'จัดเรียงผลการค้นหาใหม่อีกครั้งก่อนส่งคืนผลลัพธ์ ซึ่งอาจช่วยเพิ่มคุณภาพของผลลัพธ์ แต่จะทำให้การค้นหาช้าลงอย่างมาก',
  'pages.chat.selectContext.tootlTipRestrict':
    'คุณสามารถใช้เมนูนี้เพื่อจำกัดไฟล์ที่โมเดลสามารถใช้งานได้',
  'pages.chat.hybridSearchAlphaTooltip':
    'อัตราส่วนการค้นหาควบคุมสมดุลระหว่างการค้นหาเชิงความหมายและการค้นหาด้วยคำสำคัญ ค่าต่ำจะเน้นการค้นหาด้วยคำสำคัญ ส่วนค่าสูงจะเน้นการค้นหาเชิงความหมาย',
  'pages.chat.favoriteFileWeight':
    'น้ำหนักนี้จะเพิ่มอันดับการค้นหาของไฟล์ที่ถูกใจเป็นพิเศษโดยเทียม',
  'pages.dashboard.realTimeUsersTitleTooltip':
    'จำนวนผู้ใช้ที่กำลังโต้ตอบกับบอทอยู่ในขณะนี้ หรือได้โต้ตอบกับบอทภายใน 5 นาทีที่ผ่านมา',
  'pages.dashboard.activeUsersTitleTooltip': 'จำนวนผู้ใช้ที่โต้ตอบกับบอทในช่วงเวลาที่เลือก',
  'pages.dashboard.newUsersTitleTooltip':
    'จำนวนผู้ใช้ที่โต้ตอบกับบอทเป็นครั้งแรกในช่วงเวลาที่เลือก',
  'pages.dashboard.promptTokensTitleTooltip': 'จำนวนโทเค็นอินพุตที่ประมวลผลในช่วงเวลาที่เลือก',
  'pages.dashboard.completionTokensTitleTooltip':
    'จำนวนโทเค็นเอาต์พุตที่สร้างขึ้นในช่วงเวลาที่เลือก',
  'pages.dashboard.userMessagesTitleTooltip': 'จำนวนข้อความที่ผู้ใช้ส่งในช่วงเวลาที่เลือก',
  'pages.dashboard.storyboardsTitleTooltip':
    'จำนวนข้อความผู้ใช้ที่จัดการโดยสตอรี่บอร์ดแชทบอทสำเร็จรูปในช่วงเวลาที่เลือก',
  'pages.dashboard.botMessagesTitleTooltip': 'จำนวนข้อความที่บอทส่งถึงผู้ใช้ในช่วงเวลาที่เลือก',
  'pages.dashboard.broadcastsTitleTooltip':
    'จำนวนข้อความที่ส่งถึงผู้ใช้ซึ่งริเริ่มโดยบอทผ่านฟังก์ชันการออกอากาศในช่วงเวลาที่เลือก',
  'pages.dashboard.repliesTitleTooltip':
    'จำนวนข้อความที่ส่งถึงผู้ใช้เพื่อตอบกลับข้อความของผู้ใช้ในช่วงเวลาที่เลือก',
  'pages.dashboard.messageExchangesTitleTooltip':
    'จำนวนข้อความที่แลกเปลี่ยนระหว่างผู้ใช้และบอทในช่วงเวลาที่เลือก',
  'pages.dashboard.broadcastTitleTooltip': 'จำนวนการออกอากาศที่ริเริ่มโดยบอทในช่วงเวลาที่เลือก',
  'pages.dashboard.outReachTitleTooltip': 'ผลรวมจำนวนผู้รับของการออกอากาศทั้งหมดในช่วงเวลาที่เลือก',
  'pages.chat.stopGenerating': 'หยุดสร้างแล้ว',
  'pages.chat.stopGenerating.error': 'หยุดการสร้างไม่สำเร็จ',
  'pages.app.timeline': 'ไทม์ไลน์',
  'pages.app.guided_summary': 'สรุปแบบมีคำแนะนำ',
  'pages.app.standard_info': 'ข้อมูลด่วน',
  'pages.login.microsoftSSO': 'เข้าสู่ระบบด้วย Microsoft',
  'pages.login.loading': 'กำลังโหลด...',
  'pages.login.redirectingToMS': 'กำลังเปลี่ยนเส้นทางไปยัง Microsoft SSO...',
  'pages.loggedOut.title': 'ออกจากระบบแล้ว',
  'pages.loggedOut.heading': 'คุณได้ออกจากระบบแล้ว',
  'pages.loggedOut.description':
    'คุณสามารถปิดหน้าต่างนี้ หรือกลับไปที่หน้าเข้าสู่ระบบเพื่อเข้าสู่ระบบอีกครั้ง',
  'pages.loggedOut.return': 'กลับไปเข้าสู่ระบบ',
};
